import Model from "./Model";

export const SituacaoAutorizacao = {
  ATIVA: 1,
  DESATIVADA: 0,
};

export default class Autorizacao extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }

  get ativa() {
    return this.situacao === SituacaoAutorizacao.ATIVA;
  }

  get desativada() {
    return this.situacao === SituacaoAutorizacao.DESATIVADA;
  }
}
